import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { UPDATE_EMAIL_MUTATION, ME_QUERY } from '../../apollo/queries/userQueries';
import '../css/EmailChangePage.css';

const EmailChangePageContent = () => {
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // 현재 사용자 정보 가져오기
    const { data: userData } = useQuery(ME_QUERY);

    // 이메일 업데이트 mutation
    const [updateEmail] = useMutation(UPDATE_EMAIL_MUTATION, {
        onCompleted: () => {
            setLoading(false);
            setStep(3);
        },
        onError: (error) => {
            setLoading(false);
            alert(`이메일 변경 실패: ${error.message}`);
        },
        refetchQueries: [{ query: ME_QUERY }]
    });

    React.useEffect(() => {
        if (userData?.me?.email) {
            setEmail(userData.me.email);
        }
    }, [userData]);

    const handleNextStep = () => {
        if (step === 1) {
            // 이메일 유효성 검사
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                alert('올바른 이메일 주소를 입력해주세요.');
                return;
            }
            setStep(2);
        } else if (step === 2) {
            // 실제 이메일 업데이트 실행
            handleEmailUpdate();
        }
    };

    const handlePrevStep = () => setStep(step - 1);

    const handleEmailUpdate = async () => {
        if (loading) return;
        
        setLoading(true);
        try {
            await updateEmail({
                variables: {
                    input: { email }
                }
            });
        } catch (error) {
            console.error('이메일 업데이트 에러:', error);
        }
    };

    const renderStep1 = () => (
        <div className="ecp-step-container">
            <h2 className="ecp-section-title">이메일 주소</h2>
            <div className="ecp-form-row">
                 <label htmlFor="email">이메일 주소</label>
                 <input 
                    type="email" 
                    id="email" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="새 이메일 주소를 입력하세요"
                 />
            </div>
            <div className="ecp-actions">
                <button 
                    className="ecp-confirm-btn-large" 
                    onClick={handleNextStep}
                    disabled={!email.trim()}
                >
                    입력 완료
                </button>
            </div>
        </div>
    );

    const renderStep2 = () => (
        <div className="ecp-step-container">
             <h2 className="ecp-section-title">이메일 주소</h2>
            <div className="ecp-summary-row">
                <span className="label">현재 이메일</span>
                <span>{userData?.me?.email || ''}</span>
            </div>
            <div className="ecp-summary-row">
                <span className="label">새 이메일 주소</span>
                <span>{email}</span>
            </div>
             <div className="ecp-actions space-between">
                <button className="ecp-back-btn" onClick={handlePrevStep}>돌아가기</button>
                <button 
                    className="ecp-confirm-btn" 
                    onClick={handleNextStep}
                    disabled={loading}
                >
                    {loading ? '변경 중...' : '확인'}
                </button>
            </div>
        </div>
    );

    const renderStep3 = () => (
        <div className="ecp-step-container centered-content">
            <h2 className="ecp-final-title">이메일 주소가 성공적으로 변경되었습니다.</h2>
            <p className="ecp-final-text">새 이메일 주소: {email}</p>
            <div className="ecp-actions">
                <button className="ecp-black-btn" onClick={() => navigate('/my-page')}>마이페이지로 돌아가기</button>
            </div>
        </div>
    );

    return (
        <div className="email-change-page">
            <div className="ecp-breadcrumb">
                <span>홈</span> &gt; <span>내 정보</span> &gt; <span>사용자 정보 변경</span> &gt; <span className="current">이메일 주소 변경</span>
            </div>
            <h1 className="ecp-main-title">이메일 주소 변경</h1>
            <div className={`ecp-progress-indicator step-${step}`}>
                 <div className="step-item active">
                    <div className="circle"></div>
                    <span>정보 입력</span>
                </div>
                <div className={`step-item ${step >= 2 ? 'active' : ''}`}>
                    <div className="circle"></div>
                    <span>입력한 내용 확인</span>
                </div>
                <div className={`step-item ${step >= 3 ? 'active' : ''}`}>
                    <div className="circle"></div>
                    <span>변경완료</span>
                </div>
            </div>

            {step === 1 && renderStep1()}
            {step === 2 && renderStep2()}
            {step === 3 && renderStep3()}
        </div>
    );
};

const EmailChangePage = () => {
    return (
        <EmailChangePageContent />
    );
};

export default EmailChangePage; 